/* 動的実装前の仮データ */

export const CLINIC_NAME: string = '足と歩行のクリニック(六本木院)';
export const MEDICAL_CARE_TITLE: string = '診療申込・同意';
export const NURSING_CARE_TITLE: string = 'サービス利用申込';
export const MEDICAL_PROCEDURES_TEXT: string = `【予防の推進】
  ・足病の再発または発症予防の指導、医療提案を行います
  【セルフケアのお願い】
  ・自宅でのセルフケア(無料)または自費診療で
  【症状部位以外の検査】
  ・比較のため症状のない側のレントゲンも撮影します
  ・症状によっては胸椎や腰、股関節等のレントゲン検査を行う場合があります
  【自費診療は希望者のみ】
  ・実費検査やリハビリは保険診療実施の後検討が可能です
  【院内の撮影】
  ・安全確保と患者誘導の効率化から院内カメラが設置されています`;
